import { reducerWrapper } from '../support/utils';
import { LOADING_STATUS } from '../support/constants';

import { SDK_INFO_GET, SDK_LATEST_INFO } from '../actions/SDKInfoActions';

var INIT_STATE = {
  loading: false,
  loadingStatus: LOADING_STATUS.INIT,
  sdkInfoLoadingStatus: LOADING_STATUS.INIT,
  sdkLatestLoadingStatus: LOADING_STATUS.INIT,
  error: null,
  data: {},
};

function Handler(state, action) {
  switch (action.type) {
    case SDK_INFO_GET.response:
      return Object.assign({}, state, {
        loading: false,
        loadingStatus: LOADING_STATUS.LOADED,
        sdkInfoLoadingStatus: LOADING_STATUS.LOADED,
        error: null,
        data: Object.assign({}, state.data, action.data),
      });
    case SDK_LATEST_INFO.response:
      return Object.assign({}, state, {
        loading: false,
        loadingStatus: LOADING_STATUS.LOADED,
        sdkLatestLoadingStatus: LOADING_STATUS.LOADED,
        error: null,
        data: Object.assign({}, state.data, action.data),
      });
    case SDK_INFO_GET.request:
      return Object.assign({}, state, {
        loading: false,
        loadingStatus: LOADING_STATUS.LOADING,
        sdkInfoLoadingStatus: LOADING_STATUS.LOADING,
        error: null,
      });
    case SDK_LATEST_INFO.request:
      return Object.assign({}, state, {
        loading: false,
        loadingStatus: LOADING_STATUS.LOADING,
        sdkLatestLoadingStatus: LOADING_STATUS.LOADING,
        error: null,
      });

    default:
      return state;
  }
}

const SDKInfo = reducerWrapper(INIT_STATE, Handler, {
  request: [],
  error: [SDK_INFO_GET, SDK_LATEST_INFO],
  resetOn: ['APP_CHANGE'],
});

export default SDKInfo;
